import { render, staticRenderFns } from "./LMenu.vue?vue&type=template&id=27d7a9ff&scoped=true&"
import script from "./LMenu.vue?vue&type=script&lang=js&"
export * from "./LMenu.vue?vue&type=script&lang=js&"
import style0 from "./LMenu.vue?vue&type=style&index=0&id=27d7a9ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d7a9ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/s01-aiart-develop-cn/s01_haiyiai_develop-cn_aiart-web-openapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27d7a9ff')) {
      api.createRecord('27d7a9ff', component.options)
    } else {
      api.reload('27d7a9ff', component.options)
    }
    module.hot.accept("./LMenu.vue?vue&type=template&id=27d7a9ff&scoped=true&", function () {
      api.rerender('27d7a9ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/LMenu.vue"
export default component.exports